export interface GuestLoginParams {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  is_cart?: boolean;
}

export interface GuestData {
  clid: number;
  email: string;
  guestid: number;
  is_guest: 0 | 1;
  first_name: string;
  last_name: string;
  name: string;
  orderid: number;
  invoice_id?: number;
  phone: string;
  token: string;
  zip?: string;
}

export enum GuestCheckoutType {
  GIFT_CARDS = 'gift-cards',
  CART = 'cart'
}
